<template>
  <textarea
    v-on:input="sendNewInputToParent"
    v-model="text"
    placeholder="tutaj wpisz tresc"
  ></textarea>
</template>

<script>
export default {
  data() {
    return {
      text: "",
    };
  },
  methods: {
    sendNewInputToParent() {
      this.$emit("form_update_notification", this.text);
    },
  },
};
</script>

<style scoped>
textarea {
  margin: 0;
  border: 0;
  padding: 0;
  resize: none;
}
</style>
